<template>
  <div
    class="mk-autoweb-image-hover"
    style="background: url('https://www.yonyou.com/yingxiao/erp/images/index/index-splan-bg.jpg');background-size: cover;"
  >
    <div class="w1200 animate_top mk-autoweb-image-hover-box">
      <div class="subject-component-title center">{{ element.titleBarName }}</div>
      <ul>
        <li
          class="mk-autoweb-image-hover-li fadeIn"
          :key="index"
          v-for="(item, index) in childItem.propsValue.data"
        >
          <div
            :class="index == 0 ? 'text disactive' : 'text'"
            :style="{
              width: itemZhaiWidth,
              background: 'url('+ item.customField3 +')',
              'backgroundSize': 'cover'
            }"
          >
            <p>{{ item.customField1 }}</p>
          </div>
          <div
            :class="index == 0 ? 'info active' : 'info'"
            :style="{
              background: 'url('+ item.customField4 +')',
              'backgroundSize': 'cover'
            }"
          >
            <h3>{{ item.customField1 }}</h3>
            <p v-html="item.customField2"></p>
          </div>
        </li>
      </ul>
      <div class="mk-subject-btn-block">
        <a class="mk-subject-btn mk-ldy-btn">{{ childItem.propsValue.buttonInfo.text }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkImageHoverWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    itemZhaiWidth: function() {
      // 总宽度 844
      // 宽 180
      // 窄 (884-180) / (item.length - 1)
      return parseInt(664 / (this.childItem.propsValue.data.length - 1)) + 'px';
    }
  },
  data() {
    return {
      max: 12,
      min: 6,
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "richtext"
        },
        {
          code: "customField3",
          label: "窄图",
          type: "image",
          width: 110,
          height: 520
        },
        {
          code: "customField4",
          label: "宽图",
          type: "image",
          width: 320,
          height: 520
        }
      ],
      data: [
        {
          customField1: "总经理",
          customField2:
            "<p>移动审批与业务处理</p><p>产品研发进度与创新动态</p><p>企业经营状况和目标完成率</p><p>大客户合作情况及满意度</p><p>人才状况和梯队建设</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm5LeAPYyGAACYu8wYRkQ683.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm5SCAV2D2AAGiitX-ijc542.jpg"
        },
        {
          customField1: "IT总监",
          customField2:
            "<p>数字化建模和数据中台、智能中台</p><p>扩容升迁，业务全球化，多组织发展</p><p>定制化需求，低代码开发</p><p>数据备份与快速恢复</p><p>集成生态，融合现有IT系统</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6LqAIwZlAADWoWuJ8RU192.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6LWAdxjzAAIV0HfFgig632.jpg"
        },
        {
          customField1: "财务总监",
          customField2:
            "<p>预算、核算、结算三合一，合并报表</p><p>电子发票自动处理归档，一键报税</p><p>移动报销审批，商旅、餐饮在线预订</p><p>银企直连，在线支付</p><p>业财税金一体化，掌控业务全局</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6OWALUR-AAB-mRvShHg470.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6OKAd40bAAGMFQCjZmE201.jpg"
        },
        {
          customField1: "人力总监",
          customField2:
            "<p>多渠道岗位发布和人才评估</p><p>人才库储备、线上线下培训</p><p>考勤移动化、薪资核算自动化</p><p>人事合同全程数字化签署</p><p>在线绩效评估、员工一站式HR服务</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6RyALqghAACCQfXdA3I985.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6SCASkdTAAFRp1RZZIs851.jpg"
        },
        {
          customField1: "人力总监",
          customField2:
            "<p>多渠道岗位发布和人才评估</p><p>人才库储备、线上线下培训</p><p>考勤移动化、薪资核算自动化</p><p>人事合同全程数字化签署</p><p>在线绩效评估、员工一站式HR服务</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6RyALqghAACCQfXdA3I985.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6SCASkdTAAFRp1RZZIs851.jpg"
        },
        {
          customField1: "人力总监",
          customField2:
            "<p>多渠道岗位发布和人才评估</p><p>人才库储备、线上线下培训</p><p>考勤移动化、薪资核算自动化</p><p>人事合同全程数字化签署</p><p>在线绩效评估、员工一站式HR服务</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6RyALqghAACCQfXdA3I985.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6SCASkdTAAFRp1RZZIs851.jpg"
        },
        {
          customField1: "人力总监",
          customField2:
            "<p>多渠道岗位发布和人才评估</p><p>人才库储备、线上线下培训</p><p>考勤移动化、薪资核算自动化</p><p>人事合同全程数字化签署</p><p>在线绩效评估、员工一站式HR服务</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6RyALqghAACCQfXdA3I985.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6SCASkdTAAFRp1RZZIs851.jpg"
        },
        {
          customField1: "人力总监",
          customField2:
            "<p>多渠道岗位发布和人才评估</p><p>人才库储备、线上线下培训</p><p>考勤移动化、薪资核算自动化</p><p>人事合同全程数字化签署</p><p>在线绩效评估、员工一站式HR服务</p>",
          customField3:
            "https://mks.yybip.com/group1/M00/09/9B/CgoRC2Rm6RyALqghAACCQfXdA3I985.jpg",
          customField4:
            "https://mks.yybip.com/group1/M00/01/EC/CgoRDGRm6SCASkdTAAFRp1RZZIs851.jpg"
        }
      ],
      buttonInfo: {
        text: "获取数智化解决方案",
        beforeClick: {
          type: 0, // 0 直接访问使用， 1 填写表单后有效
          form: "", // 表单ID，按钮点击需填写表单
          formtime: "无", // 表单有效期  无 一天 七天 永久
        },
        afterClick: {
          type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
          url: "",
          contentType: "data", // data 资料， article 文章， video 视频
          contentId: "",
        },
      },
    };
  }
};
</script>

<style lang="scss" scoped>
.mk-autoweb-image-hover {
  width: 100%;
  min-height: 420px;
  padding: 18px;
}

.subject-component-title {
  font-size: 22px;
  line-height: 44px;
  color: #e31924;
}

.mk-autoweb-image-hover-box ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.mk-autoweb-image-hover-li {
  position: relative;
  height: 290px;
  margin-bottom: 6px;
}

.mk-autoweb-image-hover-li .text {
  height: 100%;
}

.mk-autoweb-image-hover-li .text p {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 16px;
  text-align: center;
  padding-top: 260px;
}

.mk-autoweb-image-hover-li .info {
  width: 180px;
  height: 100%;
  display: none;
}

.mk-autoweb-image-hover-li .info h3 {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  line-height: 16px;
  padding-top: 120px;
  margin-left: 12px;
  margin-bottom: 10px;
}

.mk-autoweb-image-hover-li .info span {
  display: inline-block;
  width: 7px;
  height: 7px;
  background: #ffffff;
  transform: rotate(45deg);
  vertical-align: middle;
  border-radius: 1px;
  margin-top: -3px;
  margin-right: 8px;
}

.mk-autoweb-image-hover-li .info p {
  font-size: 12px !important;
  color: #ffffff !important;
  line-height: 16px !important;
  margin-left: 6px !important;
  padding-right: 0px !important;
}

.mk-autoweb-image-hover-li .disactive {
  display: none;
}

.mk-autoweb-image-hover-li .active {
  display: block;
}

.mk-subject-btn-block {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}

a.mk-subject-btn {
  display: block;
  width: 220px;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
  border-radius: 6px;
}
a:hover.mk-subject-btn {
  background-image: linear-gradient(-131deg, #e5732d 0%, #e31924 52%);
}
</style>
